/* Pfeiltasten-Navigation in der Leistungswahl (Abnahme: Varianten
   tastaturbedienbar).

   Roving tabindex: nur die aktive Stufe ist im Tabfluss, die Pfeiltasten
   wandern innerhalb der Gruppe. Gesperrte Stufen werden uebersprungen —
   sie fuehren nirgendwohin.

   Vanilla, kein Framework, `defer` geladen. */
(() => {
  const gruppen = document.querySelectorAll('[data-rc-serie-keys]');
  if (!gruppen.length) return;

  gruppen.forEach((gruppe) => {
    const chips = () => Array.from(gruppe.querySelectorAll('[role="radio"]'))
      .filter((c) => c.getAttribute('aria-disabled') !== 'true');

    gruppe.addEventListener('keydown', (e) => {
      const tasten = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (!tasten.includes(e.key)) return;
      const liste = chips();
      if (liste.length < 2) return;
      const jetzt = liste.indexOf(document.activeElement);
      if (jetzt === -1) return;
      e.preventDefault();

      let ziel;
      if (e.key === 'Home') ziel = 0;
      else if (e.key === 'End') ziel = liste.length - 1;
      else {
        const vor = e.key === 'ArrowRight' || e.key === 'ArrowDown';
        ziel = (jetzt + (vor ? 1 : -1) + liste.length) % liste.length;
      }

      liste.forEach((c) => c.setAttribute('tabindex', '-1'));
      liste[ziel].setAttribute('tabindex', '0');
      liste[ziel].focus();
    });
  });
})();
